app.mediator.registerModule(MODULE_NAME__FORGOTTEN_PASSWORD_FORM, function (app) {

    var dataStore = app.data;

    return {

        // The jQuery DOM element that is the register form
        $formElem: null,

        // The JDA validator object - a wrapper around validateJS. Created on init().
        jdaValidator: null,

        isDomLoaded: false,

        //==========================================================xdiv2====
        // Start and stop
        //===================================================================

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
                this.isDomLoaded = true;
            }
        },

        // Runs in mediator start lifecycle
        init: function () {

            var scope = this;

            // Assign root DOM node, and halt execution if it is empty
            this.$formElem = $('#form-forgotten-password');
            if (!this.$formElem.length) return;

            // Create jda validator instance
            var baseConstraints = dataStore.get('validation.forgottenPasswordForm');
            this.jdaValidator = app.validator.build({}, this.$formElem);

            // Add constraints data to validator
            this.jdaValidator.constraintBag.addConstraints(baseConstraints);

            // Add DOM event listeners
            this.addDomListeners();

            // On submit, check for validation, then submit
            this.$formElem.submit(function (e) {
                scope.handleFormSubmit(e);
            });

            app.mediator.notify(EVENT_NAME__FORGOTTEN_PASSWORD_FORM__INITIATED);

        },

        //==========================================================xdiv2====
        // DOM event listeners
        //===================================================================

        addDomListeners: function () {
            var scope = this;
            this.$formElem.find('input[type=email]').keyup(function (e) {
                if (scope.jdaValidator.configuration.keyUpShouldBeIgnored(e)) return;
                var $elem = $(this);
                scope.handleElemChange($elem);
            });

        },

        //==========================================================xdiv2====
        // DOM event handlers
        //===================================================================

        handleFormSubmit: function (e) {
            var messageBag = this.jdaValidator.getMessageBag();
            this.jdaValidator.presenter.clearStatuses();
            this.jdaValidator.presenter.showStatuses(messageBag);
            if (messageBag.hasMessages()) {
                e.preventDefault();
                this.jdaValidator.presenter.scrollToFirstError();
            }
        },

        handleElemChange: function ($elem) {
            var formFieldId = this.jdaValidator.configuration.getFormFieldId($elem);
            var messageBag = this.jdaValidator.getMessageBagForFormField(formFieldId);
            this.jdaValidator.presenter.clearStatus($elem);
            this.jdaValidator.presenter.showStatus($elem, messageBag);
        },

    };
});
